module.exports = __webpack_public_path__ + "img/image-003.8ff937a9.png";